import { useState, useEffect } from 'react';
import { Radio } from '@mui/material';

import PropTypes from 'prop-types';

import _ from 'lodash';
import { useRouter } from 'next/router';


const BlogMobileFilters = (props) => {
    const { onChange, tags } = props;
    const tagData = tags;

    const [selectedTag, setSelectedTag] = useState(null);
    const [isSelected, setIsSelected] = useState(false);

    const router = useRouter();
    const { query } = router;

    useEffect(() => {
        getTagParamFromQuery();
    }, []);

    const onTagSelect = (value) => {

        setSelectedTag(value);
        setIsSelected(!false);
        if (onChange) {
            onChange(value);
        }
    };

    const getTagParamFromQuery = () => {
        const tagParam = _.get(query, 'filter');
        setSelectedTag(tagParam);

        if (onChange) {
            onChange(tagParam);
        }
    };

    const renderCheckboxes = () => {
        return _.map(tagData, (tag) => {
            const label = _.get(tag, 'name');
            const value = _.get(tag, 'id');
            return (

                <div className='blog-mobile-filter-row' onClick={() => onTagSelect(value)}>

                    <div className='blog-mobile-filter-checkbox-wrapper'>

                        <Radio checked={selectedTag === value} disableRipple />

                    </div>

                    <div>

                        <h6 className={isSelected ? 'blog-mobile-filter-paragraph-dark' : 'blog-mobile-filter-paragraph-medium'}>{label}</h6>

                    </div>

                </div>

            );
        });
    };

    return (
        <>
            <div className='blog-mobile-filter-row' onClick={() => onTagSelect('all')}>

                <div className='blog-mobile-filter-checkbox-wrapper'>

                    <Radio checked={selectedTag === 'all'} disableRipple />

                </div>

                <div>

                    <h6 className={isSelected ? 'blog-mobile-filter-paragraph-dark' : 'blog-mobile-filter-paragraph-medium'}>All</h6>

                </div>

            </div>

            {renderCheckboxes()}

        </>
    );
};

export default BlogMobileFilters;

BlogMobileFilters.propTypes = {
    tags: PropTypes.array,
    onChange: PropTypes.func,
};

